import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import variables from '../../utils/variables';
import { ReactComponent as ArrowIcon } from '../../assets/top_right_arrow.svg';
import { ReactComponent as ArrowFirstIcon } from '../../assets/top_right_first.svg';

const TotalSale = (props) => {
    let royalty = props.totalSale && props.totalSale.details && props.totalSale.details.royalty_share;
    royalty = royalty * 100;
    return (props.totalSale && props.totalSale.splitInfo && props.totalSale.splitInfo.length)
        ? (
            <div className="total_sale">
                <h3>{variables[props.lang]['total_collaborators_breakdown']}</h3>
                <div className="row">
                    <p className="label">{variables[props.lang]['collaborators_breakdown']}&nbsp;({100}%)</p>
                </div>
                {props.totalSale.splitInfo.map((val, index) => {
                    const weight = props.deList
                        ? val.weight && Number(val.weight) * 100
                        : val.weight && Number(val.weight);

                    return val.address !== '' && val.weight !== '' && (
                        <div
                            key={index}
                            className={royalty ? 'royalty_splits row info splits_info' : 'row info splits_info'}>
                            <div className="label">
                                {index === 0
                                    ? <ArrowFirstIcon/>
                                    : <ArrowIcon/>}
                                {val.address && val.address.length > 20
                                    ? <div className="tx_hash">
                                        <div className="hash_text" title={val.address}>
                                            <p className="name">{val.address}</p>
                                            {val.address &&
                                                val.address.slice(val.address.length - 6, val.address.length)}
                                        </div>
                                    </div>
                                    : <div className="tx_hash" title={val.address}>
                                        {val.address}
                                    </div>}&nbsp;
                                ({weight && weight.toFixed(2)}%)
                            </div>
                        </div>
                    );
                })}
            </div>
        ) : null;
};

TotalSale.propTypes = {
    address: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    totalSale: PropTypes.object.isRequired,
    deList: PropTypes.bool,
};

const stateToProps = (state) => {
    return {
        address: state.account.connection.address,
        lang: state.language,
    };
};

export default connect(stateToProps)(TotalSale);
